module.exports = __webpack_public_path__ + "0672d465e0c87ceeaef79c8a858c7eb1.svg";